import { useUnit } from 'effector-react';
import { DataGrid } from '@unicorn-shared/interface';
import {
  relatedTicketsColumns,
  $selectedRows,
  $tableData,
  $orderedColumns,
  $resizedColumns,
  setSelectedRows,
  setOrderedColumns,
  setResizedColumns,
  resetOrderedColumns,
  resetResizedColumns,
} from '../../../models/related-tickets';

export interface TableProps {
  isLoading: boolean;
}

export const Table = (props: TableProps) => {
  const { isLoading } = props;
  const [tableData, selectedRows, orderedColumns, resizedColumns] = useUnit([
    $tableData,
    $selectedRows,
    $orderedColumns,
    $resizedColumns,
  ]);

  return (
    <DataGrid
      name="related-tickets"
      columns={relatedTicketsColumns}
      rows={tableData}
      loading={isLoading}
      canSelectRows
      showPagination={false}
      showAllRows
      externals={{
        selectedRows,
        setSelectedRows,
        orderedColumns,
        setOrderedColumns,
        resetOrderedColumns,
        resizedColumns,
        setResizedColumns,
        resetResizedColumns,
      }}
    />
  );
};
